/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kcal: NonNullable<unknown> }} Filter_Max_KcalInputs */

const en_filter_max_kcal = /** @type {(inputs: Filter_Max_KcalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≤ ${i?.kcal} kcal`)
};

const de_filter_max_kcal = /** @type {(inputs: Filter_Max_KcalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≤ ${i?.kcal} kcal`)
};

/**
* | output |
* | --- |
* | "≤ {kcal} kcal" |
*
* @param {Filter_Max_KcalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_max_kcal = /** @type {((inputs: Filter_Max_KcalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Max_KcalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_max_kcal(inputs)
	return en_filter_max_kcal(inputs)
});